












































































































import { Component } from "vue-property-decorator";
import { VoiceFocusDelegate } from "amazon-chime-sdk-js/libs/voicefocus/types";
import { LAYOUT_TYPE, MEETING_TYPE } from "@/resources/constants/meeting";
import { GAME_TYPE } from "@/resources/constants/games";
import { UtilitiesGames } from "@/helpers/games/utilitiesGames";
import { mixins } from "vue-class-component";
import Chime from "@/resources/mixins/chime/chime";
@Component({
  name: "call-content-component",
})
export default class CallContentComponent extends mixins(Chime) {
  MEETING_TYPE = MEETING_TYPE;
  LAYOUT_TYPES = LAYOUT_TYPE;
  videoUrlExpanded = true;
  urlGame = "";
  isParticipants = true;
  timer = null;
  created(): void {
    if (this.meetingType != MEETING_TYPE.GAME)
      this.$store.dispatch("MeetingStore/setActiveGameAction", false);
  }
  mounted() {
    const scrollContainer = document.getElementById("meeting-participants");
    scrollContainer.addEventListener("wheel", (e) => {
      scrollContainer.scrollLeft += e.deltaY;
    });

    const meetingType = this.$store.getters["MeetingStore/getMeetingType"];
    const space = this.$store.getters["SpaceStore/getSpace"];
    if (
      meetingType === MEETING_TYPE.WEBINAR &&
      (space.superSpace.isMultiWebinarActivated
        ? !this.isMultiWebinarUser()
        : !this.isWebinarUser())
    ) {
      const localParticipant = document.getElementById("local-participant");
      if (localParticipant) localParticipant.style.display = "none";
    }

    if (this.meetingType == MEETING_TYPE.WEBINAR) this.getParticipants();
  }
  beforeUnmount() {
    document
      .getElementById("meeting-participants")
      .removeEventListener("wheel", () => {
        //do nothing
      });
  }
  destroyed(): void {
    this.$store.dispatch("MeetingStore/setActiveGameAction", false);
    if (this.timer) clearInterval(this.timer);
  }
  get localVideoPoster(): void {
    const localSpaceUSer = this.$store.getters["UserStore/getSpaceUser"];
    return localSpaceUSer.superSpaceUser.user.profileImage
      ? localSpaceUSer.superSpaceUser.user.profileImage.url
      : require("@/assets/images/logo/favicon.png");
  }
  get videoUrl(): string {
    return this.convertToEmbed(
      this.$store.getters["MeetingStore/getVideoUrl"] || ""
    );
  }
  get layoutType(): string {
    return this.$store.getters["MeetingStore/getLayoutType"];
  }
  get meetingType(): string {
    return this.$store.getters["MeetingStore/getMeetingType"];
  }
  get columnDisplay(): boolean {
    return this.$store.getters["MeetingStore/getColumnDisplay"];
  }
  get activeParticipant(): VoiceFocusDelegate {
    return this.$store.getters["MeetingStore/getActiveParticipant"];
  }
  get activeGame(): boolean {
    const user = this.$store.getters["UserStore/getSpaceUser"];
    const meeting = this.$store.getters["MeetingStore/getMeeting"];
    if (meeting)
      this.urlGame = UtilitiesGames.getUrlGame(
        GAME_TYPE.PONG,
        meeting.MeetingId,
        user.superSpaceUser.user.name
      );
    //return this.$store.getters["MeetingStore/getActiveGame"];
    return false;
  }
  get expand(): boolean {
    return this.$store.getters["MeetingStore/getColumnDisplay"];
  }
  isTopShare() {
    let type = localStorage.getItem("layout");
    if (type == "TOP_SHARE") return true;
    return false;
  }
  openExpad(): void {
    this.$store.dispatch("MeetingStore/setColumnDisplayAction", false);
    this.$store.dispatch("SidebarStore/setSidebarFullAction", false);
    this.onDisplayModeChange();
  }
  convertToEmbed(url: string): string {
    if (url.includes("twitch"))
      return `${url}&parent=${window.location.hostname}`;
    const replace = url
      .replace(
        /(?:http:|https:)?(?:\/\/)(?:www\.)?(?:youtube\.com|youtu\.be)\/(?:watch\?v=)?([^<.,!():"'\s]+)/g,
        "https://www.youtube.com/embed/$1"
      )
      .replace(
        /(?:http:|https:)?(?:\/\/)(?:www\.)?(?:vimeo\.com)\/([^<.,!():"'\s]+)/g,
        "//player.vimeo.com/video/$1"
      )
      .replace(
        /(?:http:|https:)?(?:\/\/)(?:dailymotion\.com|dai\.ly)\/([^<.,!():"'\s]+)/g,
        "https://www.dailymotion.com/embed/video/$1"
      )
      .split("&")[0];
    return replace;
  }
  getParticipants() {
    let activeParticipants = null;
    let expandedParticipant = null;
    this.timer = setTimeout(() => {
      expandedParticipant = document.getElementById(
        "expanded-participant"
      )?.children;
      activeParticipants = document.getElementById(
        "meeting-participants"
      )?.children;
      if (activeParticipants) {
        if (activeParticipants.length == 1) {
          if (
            activeParticipants[0].id == "local-participant" &&
            getComputedStyle(activeParticipants[0]).display != "none"
          ) {
            this.isParticipants = true;
            this.getParticipants();
            return;
          }
        }
        this.isParticipants = activeParticipants.length > 1 ? true : false;
      }
      if (expandedParticipant && expandedParticipant.length === 1) {
        this.isParticipants = true;
      }
      this.getParticipants();
    }, 1000);
  }
  videoUrlExpand(video) {
    this.videoUrlExpanded = video;
  }
}
